// @flow

import {
  PROJECT_GET_REQUEST, PROJECT_GET_SUCCESS,
  PROJECT_GET_FAILURE, PROJECT_CREATE_REQUEST,
  PROJECT_CREATE_SUCCESS, PROJECT_CREATE_FAILURE,
  PROJECT_UPDATE_REQUEST, PROJECT_UPDATE_SUCCESS,
  PROJECT_UPDATE_FAILURE, PRODUCTS_REQUEST,
  PRODUCTS_SUCCESS, PRODUCTS_FAILURE,
  ROOM_TYPES_REQUEST, ROOM_TYPES_SUCCESS,
  ROOM_TYPES_FAILURE, UPLOAD_PROJECT_FILE,
  REMOVE_PROJECT_FILE, ABORT_FILE_UPLOAD,
  ADD_PROJECT_FILE, ADD_ROOM_TYPE_IMAGE,
  REMOVE_ROOM_TYPE_IMAGE, UPLOAD_ROOM_TYPE_IMAGE,
  CLEAR, SET_ACTIVE_ROOM_TYPE,
  FILTER_APARTMENTS, RESET,
  ACTIVATION_REQUEST, ACTIVATION_SUCCESS,
  ACTIVATION_FAILURE, SORT,
} from '../actions/projectView';
import {SET_DIRTY} from '../actions/form';
import {combineReducers} from 'redux';
import _ from 'lodash/fp';

const defaultProjectState = {
  isFetching: false,
  active: null,
  apartments: [],
  apartmentConfigurations: [],
  error: null,
  files: {},
  roomTypeImages: [],
};

const project = (state = defaultProjectState, action) => {
  switch (action.type) {
    case PROJECT_GET_REQUEST:
      return {
        ...state,
        isFetching: true,
        active: null,
        error: null,
        apartments: defaultProjectState.apartments,
        apartmentConfigurations: defaultProjectState.apartmentConfigurations,
      };
    case PROJECT_GET_SUCCESS:
      return {
        ...state,
        isFetching: false,
        active: action.project,
        apartments: action.apartments,
        apartmentConfigurations: action.apartmentConfigurations,
        files: {
          coverImage: action.project.coverImage,
          brochure: action.project.brochure,
        },
        roomTypeImages: action.project.images,
        error: null,
      };
    case ACTIVATION_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case ACTIVATION_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
      };
    case ACTIVATION_FAILURE:
    case PROJECT_GET_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };
    case PROJECT_CREATE_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case PROJECT_CREATE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        active: action.project,
        files: {
          coverImage: action.project.coverImage,
          brochure: action.project.brochure,
        },
        roomTypeImages: action.project.images,
      };
    case PROJECT_CREATE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };
    case PROJECT_UPDATE_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case PROJECT_UPDATE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        active: action.project,
        files: {
          coverImage: action.project.coverImage,
          brochure: action.project.brochure,
        },
        roomTypeImages: action.project.images,
        error: null,
      };
    case PROJECT_UPDATE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };
    case REMOVE_PROJECT_FILE:
      return {
        ...state,
        files: {
          ...state.files,
          [action.name]: null,
        },
      };
    case ADD_PROJECT_FILE:
      return {
        ...state,
        files: {
          ...state.files,
          [action.name]: action.metadata,
        },
      };
    case ADD_ROOM_TYPE_IMAGE:
      return {
        ...state,
        roomTypeImages: [
          ...state.roomTypeImages,
          {
            roomTypeId: action.roomTypeId,
            ...action.metadata,
          },
        ],
      };
    case REMOVE_ROOM_TYPE_IMAGE:
      return {
        ...state,
        roomTypeImages: _.filter(i => i.id !== action.fileId, state.roomTypeImages),
      };
    case RESET:
      return {
        ...state,
        files: state.active ? {
          coverImage: state.active.coverImage,
          brochure: state.active.brochure,
        } : {},
        roomTypeImages: state.active ? state.active.images : [],
      };
    case CLEAR:
      return {
        ...defaultProjectState,
        apartments: state.apartments,
        apartmentConfigurations: state.apartmentConfigurations,
      };
    default:
      return state;
  }
};

const defaultProductsState = {
  isFetching: false,
  error: null,
  list: [],
};

const products = (state = defaultProductsState, action) => {
  switch (action.type) {
    case PRODUCTS_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
        list: [],
      };
    case PRODUCTS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        list: action.products,
      };
    case PRODUCTS_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };
    case CLEAR:
      return defaultProductsState;
    default:
      return state;
  }
};

const getRoomTypeIds = _.flow(
  _.flatMap('rooms'),
  _.map('roomTypeId'),
  _.uniq
);

const filteredRoomTypes = (state = [], apartmentConfigurations = [], roomTypes = [], action) => {
  switch (action.type) {
    case PROJECT_GET_SUCCESS:
    case ROOM_TYPES_SUCCESS:
      const roomTypeIds = getRoomTypeIds(apartmentConfigurations);
      return _.filter(t =>
        _.some(id => id === t.id, roomTypeIds), roomTypes
      );
    case ROOM_TYPES_REQUEST:
    case CLEAR:
      return [];
    default:
      return state;
  }
};

const defaultRoomTypesState = {
  isFetching: false,
  error: null,
  list: [],
};

const roomTypes = (state = defaultRoomTypesState, action) => {
  switch (action.type) {
    case ROOM_TYPES_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
        list: [],
      };
    case ROOM_TYPES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        list: action.roomTypes,
      };
    case ROOM_TYPES_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };
    case CLEAR:
      return defaultRoomTypesState;
    default:
      return state;
  }
};

const defaultRoomTypeState = {
  active: null,
};

const roomType = (state = defaultRoomTypeState, action) => {
  switch (action.type) {
    case SET_ACTIVE_ROOM_TYPE:
      return {
        ...state,
        active: action.roomType,
      };
    case CLEAR:
      return defaultRoomTypeState;
    default:
      return state;
  }
};

const defaultUploadIdsState = {
  projectFiles: {},
  roomTypeImages: {},
};

const uploadIds = (state = defaultUploadIdsState, action) => {
  switch (action.type) {
    case UPLOAD_PROJECT_FILE:
      return {
        ...state,
        projectFiles: {
          ...state.projectFiles,
          [action.name]: action.tempId,
        },
      };
    case UPLOAD_ROOM_TYPE_IMAGE:
      const existing = state.roomTypeImages[action.roomTypeId] || [];
      return {
        ...state,
        roomTypeImages: {
          ...state.roomTypeImages,
          [action.roomTypeId]: [
            ...existing,
            action.tempId,
          ],
        },
      };
    case ABORT_FILE_UPLOAD:
      return {
        ...state,
        projectFiles: _.omitBy(u => u === action.tempId, state.projectFiles),
        roomTypeImages: _.mapValues(_.filter(u => u !== action.tempId), state.roomTypeImages),
      };
    case CLEAR:
      return defaultUploadIdsState;
    default:
      return state;
  }
};

const defaultApartmentsFilterState = {
  query: '',
  sorter: _.identity,
};

const apartmentsFilter = (state = defaultApartmentsFilterState, action) => {
  switch (action.type) {
    case FILTER_APARTMENTS:
      return {
        ...state,
        query: action.query || '',
      };
    case SORT:
      return {
        ...state,
        sorter: action.sorter,
      };
    default:
      return state;
  }
};

const isDirty = (state = false, action) => {
  switch (action.type) {
    case SET_DIRTY:
      return action.form === 'project'
        ? action.dirty
        : state;
    case PROJECT_GET_SUCCESS:
    case PROJECT_CREATE_SUCCESS:
    case PROJECT_UPDATE_SUCCESS:
    case CLEAR:
      return false;
    default:
      return state;
  }
};

const filterQuery = query => {
  query = _.toLower(query || '');
  return _.isEmpty(query)
    ? _.identity
    : _.filter(x =>
      _.includes(query, _.toLower(x.objectId)) ||
      _.includes(query, _.toLower(x.area)) ||
      _.includes(query, _.toLower(x.address))
    );
};

const filteredApartments = ({
  apartmentsFilter: {
    query,
    sorter,
  },
  project: {
    apartments,
  },
}, action) => _.flow(
  filterQuery(query),
  sorter,
)(apartments);

const reducers = combineReducers({
  project,
  products,
  roomTypes,
  filteredRoomTypes: (state = []) => state,
  filteredApartments: (state = []) => state,
  roomType,
  uploadIds,
  apartmentsFilter,
  isDirty,
});

const projectView = (state: any = {}, action: any) => {
  const newState = reducers(state, action);
  return {
    ...newState,
    filteredRoomTypes: filteredRoomTypes(
      newState.filteredRoomTypes,
      newState.project.apartmentConfigurations,
      newState.roomTypes.list,
      action),
    filteredApartments: filteredApartments(
      newState,
      action,
    ),
  };
};

export default projectView;



// WEBPACK FOOTER //
// ./src/reducers/projectView.js